<template>
  <div :style="cssVars()">
    <p v-if="labelActive" :style="labelStyle" :class="`font-weight-normal small m-0 mb-2 ${labelClass}`">
      {{ labelActive }}
    </p>
    <div class="d-flex align-items-center">
      <input type="number" :min="min" :max="max" :value="min" class="value-input text-center" :disabled="disabled" />
      <div ref="priceSlider" class="price-slider mx-2">
        <input :value="minValue" :min="min" :max="max" :step="step" type="range" :disabled="disabled" />
        <input :value="maxValue" :min="min" :max="max" :step="step" type="range" :disabled="disabled" />
      </div>
      <input type="number" :min="min" :max="max" :value="max" :disabled="disabled" class="value-input text-center" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    minDefault: { type: Number },
    maxDefault: { type: Number },
    labelActive: { type: String },
    labelClass: { type: String },
    labelStyle: { type: [String, Object] },
    thumbColor: { type: String, default: "#000" },
    trackColor: { type: String, default: "#e5e5e5" },
    trackLabelColor: { type: String, default: "#000" },
    trackLabelAppend: { type: String },
    disabled: { type: Boolean, default: false },
    step: { type: Number, default: 1 },
  },
  emits: ["input"],
  data() {
    return {
      maxValue: !this.maxDefault ? this.max : this.maxDefault,
      minValue: !this.minDefault ? this.min : this.minDefault,
      minMouseDown: false,
      maxMouseDown: false,
      thumb: "#000",
      track: "#efefef",
    };
  },
  computed: {},
  mounted() {
    this.thumb = this.thumbColor;
    this.track = this.trackColor;

    this.initRange();
  },

  methods: {
    cssVars() {
      return {
        "--range-thumb-color": this.thumbColor,
        "--range-track-color": this.trackColor,
      };
    },
    initRange() {
      const parent = this.$refs.priceSlider;
      const rangeS = parent.querySelectorAll("input[type=range]");
      const numberS = parent.parentElement.querySelectorAll("input.value-input");
      const that = this;

      rangeS.forEach((el) => {
        el.oninput = function () {
          let slide1 = parseFloat(rangeS[0].value);
          let slide2 = parseFloat(rangeS[1].value);

          if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
          }

          numberS[0].value = slide1;
          numberS[1].value = slide2;

          that.$emit("input", {
            min: slide1,
            max: slide2,
          });
        };
      });
      numberS.forEach((el) => {
        el.onchange = function () {
          let slide1 = parseFloat(numberS[0].value);
          let slide2 = parseFloat(numberS[1].value);

          if (!slide1 || slide1 == "") {
            numberS[0].value = that.min;
            slide1 = that.min;
          }

          if (slide1 > that.max) {
            numberS[0].value = that.max;
          }

          if (!slide2 || slide2 == "") {
            numberS[1].value = that.min;
            slide2 = that.min;
          }

          if (slide2 > that.max) {
            numberS[1].value = that.max;
          }

          if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
          }

          rangeS[0].value = slide1;
          rangeS[1].value = slide2;

          that.$emit("input", {
            min: slide1,
            max: slide2,
          });
        };
      });
    },
  },
};
</script>
<style>
* {
  --range-thumb-color: #000;
  --range-track-color: #efefef;
}

.price-slider {
  width: 100%;

  text-align: center;
  position: relative;
  min-height: 7px;
}

.value-input {
  width: 40px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.value-input:disabled {
  background-color: #e9ecef;
  color: #868e96;
  cursor: not-allowed;
}

.price-slider svg,
.price-slider input[type="range"] {
  position: absolute;
  left: 0;
}

input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]:focus::-ms-fill-lower {
  background: var(--range-track-color);
}
input[type="range"]:focus::-ms-fill-upper {
  background: var(--range-track-color);
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  transition: 0.2s;
  background: var(--range-track-color);
  border-radius: 5px;
  box-shadow: none;
  border: 0;
}
input[type="range"]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #ccc;
  background: #f1f1f1;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -5px;
}
input[type="range"]::-webkit-slider-thumb:hover {
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #ccc;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  background: #e5e5e5;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -5px;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  transition: 0.2s;
  background: var(--range-track-color);
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}
input[type="range"]::-moz-range-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #1da1f2;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #a1d0ff;
  cursor: pointer;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  transition: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type="range"]::-ms-fill-lower,
input[type="range"]::-ms-fill-upper {
  background: var(--range-track-color);
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}
input[type="range"]::-ms-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #1da1f2;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #a1d0ff;
  cursor: pointer;
}
input[type="range"]:disabled::-webkit-slider-thumb,
input[type="range"]:disabled::-webkit-slider-runnable-track {
  cursor: not-allowed !important;
}
</style>
